import ApiUrl from "../../../../configTools/api";
// Guarantees the callback fires exactly once with an array, even on failure - the page
// clears its loading flag inside it, so a dropped request must not leave a shimmer spinning.
import { apiGetList } from "../../../../configTools/apiGet";

const Get = (setValues, setPages, page = 1, limit = 20) => {
    apiGetList(ApiUrl.Doctor_Orders + `?page=${page}&limit=${limit}`, (list, body)=>{
        setValues(list);
        if (setPages) setPages({ total: body.total || 0, pages: body.pages || 1, page: body.page || 1 });
    });
}

const GetByStatus = (status, setValues, setPages, page = 1, limit = 20) => {
    apiGetList(ApiUrl.Doctor_Orders+"/bystatus/"+status+`?page=${page}&limit=${limit}`, (list, body)=>{
        setValues(list);
        if (setPages) setPages({ total: body.total || 0, pages: body.pages || 1, page: body.page || 1 });
    });
}

const Functions = {Get,GetByStatus};
export default Functions;
